import { createGlobalStyle } from "styled-components";
import MontHeavy from "./fonts/Mont-Heavy.otf";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Mont Heavy';
    font-display: swap;
    src:  url(${MontHeavy});
  }  
  *, *::before, *:after {
    box-sizing: border-box;
  }
  html {
    font-size: 62.5%;
    -webkit-text-size-adjust: none;
  }
  body {
    position: relative;
    height: 100vh;
    background: rgba(235, 236, 245, 1);
    font-family: Inter, sans-serif;
    margin: 0;
    font-size: 1.2rem;
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 4px;
      border: none;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: rgba(7, 63, 145, 1);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 8px;
    }
  }
  h1 {
    font-size: 4rem;
    font-weight: bold;
  }
  h2 {
    font-size: 3.2rem;
    font-weight: bold;
  }
  h3 {
    font-size: 2.4rem;
    line-height: 1;
    font-weight: bold;
  }
  h4 {
    font-size: 1.6rem;
    font-weight: bold;
  }
  h5 {
    font-size: 1.2rem;
    font-weight: bold;
  }
  a {
    text-decoration: none;
  }
  .link-text {
    font-size: 1.4rem;
    font-weight: bold;
    color: #b6cbd8;
  }
  .body-text {
    color: rgb(21, 32, 44);
  }
  p {
    font-size: 1.2rem;
    letter-spacing: 0.05rem;
    font-weight: normal;
  }
  img {
    max-width: 100%;
    height: auto;
    align-self: center;
  }
  button,
  select {
    font-family: Quicksand, sans-serif;
  }
  .icon {
    width: 2.4rem;
    height: auto;
    &.close, &.back {
      cursor: pointer;
    }
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .disabled-text {
    color: rgb(56, 66, 77);
  }
  .font-regular {
    font-weight: 400;
  }
  .space-right {
    margin-right: 0.6rem;
  }
  .space-left {
    margin-left: 0.6rem;
  }
  .margin-right {
    margin-right: 1.2rem;
  }
  .margin-left {
    margin-left: 1.2rem;
  }
  .margin-left-base {
    margin-left: 1.8rem;
  }
  .submenu-icon {
    width: 3.8rem;
    height: 3.8rem;
    margin-right: 0.8rem
  }
  .submenu-logo {
    width: 10.8rem;
    height: 1.2rem;
  }
  .submenu-text {
    font-size: 1.2rem;
    color: rgb(182,203,216);
    margin: 0.4rem 0 0;
  }
  .ptr, .ptr-children {
    -webkit-overflow-scrolling: auto;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .no-stats-text {
    font-size: 1.4rem;
    font-weight: bold;
    color: rgb(182,203,216);
  }
`;

export default GlobalStyle;
